<template>
    <div>
        <vs-table
            stripe
            border
            :multiple="this.selection"
            v-model="selected"
            description
            :sst="true"
            :data="table.data"
            :max-items="table.length"
            :total="table.total"
            @search="handleSearch"
            @change-page="handleChangePage"
            @sort="handleSort">
            <template slot="header">
                <vs-dropdown vs-trigger-click class="cursor-pointer">
                    <div
                        class="flex items-center justify-between p-3 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                        <span class="mr-2">{{ this.table.start }} - {{ this.table.end }} of
                            {{ this.table.total }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>
                    <vs-dropdown-menu>
                        <vs-dropdown-item v-for="item in table.limits" :key="item" @click="handleChangelength(item)">
                            <span>{{ item }}</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>

                <div class="flex items-center justify-between p-2 font-medium border border-solid rounded-full cursor-pointer d-theme-border-grey-light d-theme-dark-bg">
                    <span class="mr-2">Selection </span>
                    <vs-switch v-model="selection" class="mr-2" @input="(val)=>{this.selected=[]}">
                        <span slot="on">On</span>
                        <span slot="off">Off</span>
                    </vs-switch>
                    <vs-button v-if="selected.length > 0" size="small" class="mr-2" @click="handleApproveAll">Approve
                        All</vs-button>
                    <vs-button v-if="selected.length > 0" size="small" class="mr-2" @click="handleRejectAll">Reject
                        All</vs-button>
                </div>

                <div class="con-input-search vs-table--search">
                    <input
                        type="text"
                        class="input-search vs-table--search-input"
                        placeholder="Search here"
                        v-model="search"
                        @input="onChangeSearch(search)"
                        @keyup.enter="handleSearch(search)"
                    >
                    <i class="vs-icon notranslate icon-scale material-icons null">search</i>
                </div>

                <vs-button
                    size="small"
                    color="primary"
                    type="border"
                    icon-pack="feather"
                    icon="icon-search"
                    title="Search"
                    style="margin-left: 5px"
                    @click="handleSearch(search)"
                ></vs-button>
            </template>

            <template slot="thead">
                <vs-th>Action </vs-th>
                <vs-th sort-key="code">SR Type </vs-th>
                <vs-th sort-key="code">SR Number</vs-th>
                <vs-th sort-key="code">Supplier Data</vs-th>
                <vs-th sort-key="">Warehouse</vs-th>
            </template>

            <template slot-scope="{ data }">
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                    <vs-td>
                        <div class="flex vx-input-group">
                            <vs-button size="small" color="warning" icon-pack="feather" icon="icon-eye" title="Detail"
                                style="margin-right: 5px" @click="handleDetail(tr.id, tr.purchase_order_id, tr.pro_id ? tr.pro_id : 0)" />
                            <vs-button v-if="status == 'Waiting'" size="small" color="danger" icon-pack="feather"
                                icon="icon-x-square" title="Reject" style="margin-right: 5px"
                                @click="handleReject(tr.id, tr.purchase_order_id)" />
                            <vs-button v-if="status == 'Waiting'" size="small" color="success" icon-pack="feather"
                                icon="icon-check" title="Approve" @click="handleApprove(tr.id, tr.purchase_order_id)" />
                        </div>
                    </vs-td>
                    <vs-td>
                        <div class="flex flex-col content-center">
                            {{ Number(tr.purchase_order_id) > 0 ? 'With Reference' : 'Without Reference' }}
                        </div>
                    </vs-td>
                    <vs-td>{{ tr.code }}</vs-td>
                    <vs-td key="supplier">
                        <div class="flex flex-col content-center">
                            <div>Code : {{ tr.supplier_code }}</div>
                            <div>Name : {{ tr.supplier_name }}</div>
                            <div>City : {{ tr.supplier_city }}</div>
                        </div>
                    </vs-td>
                    <vs-td key="warehouse">
                        <div v-if="tr.warehouse.id > 0" class="flex flex-col content-center">
                            <div>Code : {{ tr.warehouse.code }}</div>
                            <div>Name : {{ tr.warehouse.name }}</div>
                            <div>City : {{ tr.warehouse.city }}</div>
                        </div>
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
        <vs-pagination style="padding-top: 5px" :total="table.totalPage" v-model="setPage" />
    </div>
</template>

<script>
import moment from "moment";

export default {
    components: {},
    props: {
        draw: {
            type: Number,
        },
        sourceWarehouseId: {
            type: Number,
        },
        RefType: {
            type: String,
            default: "",
        },
        supplierId: {
            type: Number,
        },
        transactionDate: {
            type: Date,
            default: null,
        },
        status: {
            type: String,
            default: "Draft",
        },
    },
    data() {
        return {
            selection: false,
            deleteId: null,
            table: this.tableDefaultState(),
            selected: [],
            timeOuts: null,
            search: "",
            localDraw: 0,
        };
    },
    methods: {
        tableDefaultState() {
            return {
                data: [],
                length: 10,
                page: 1,
                search: "",
                order: "date",
                sort: "desc",
                total: 0,
                totalPage: 1,
                totalSearch: 0,
                limits: [10, 25, 50, 100, "All"],
                start: 1,
                end: 0,
            };
        },
        onChangeSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
        },
        handleSearch(searching) {
            this.table.search = searching;
            this.table.page = 1;
            this.localDraw++
        },
        handleChangePage(page) {
            this.table.page = page;
            this.getData();
        },
        handleSort(key, active) {
            this.table.order = key;
            this.table.sort = active;
            this.getData();
        },
        handleChangelength(val) {
            this.table.length = val == "All" ? this.table.total : val;
            this.table.page = 1;
            this.getData();
        },
        getData() {
            if (this.draw > 0 || this.localDraw > 0) {
                this.$vs.loading();
                this.$http.get(`${this.$store.state.purchase.poReturn.baseUrlPath}/approvals`, {
                    params: {
                        limit: this.table.length,
                        page: this.table.page,
                        query: this.table.search,
                        order: this.table.order,
                        sort: this.table.sort,
                        warehouse_id: this.sourceWarehouseId,
                        supplier_id: this.supplierId,
                        type: this.RefType,
                        status: this.status,
                    },
                })
                .then((resp) => {
                    if (resp.code == 200) {
                        this.table.total = resp.data.total_rows;
                        this.table.totalPage = resp.data.total_pages;
                        this.table.totalSearch = resp.data.total_record_search;
                        this.table.length = resp.data.limit;
                        this.table.data = resp.data.rows ? resp.data.rows : [];
                        this.setStartEnd();
                        this.$vs.loading.close();
                    } else {
                        this.$vs.loading.close();
                        this.$vs.dialog({
                            color: "danger",
                            title: "Something went wrong",
                            text: resp.message,
                        });
                    }
                })
                .catch(error => {
                    this.$vs.loading.close();
                    console.log(error)
                    this.$vs.dialog({
                        color: "danger",
                        title: "Something went wrong",
                        text: error,
                    });
                });
            }
        },
        setStartEnd() {
            let valStart =
                this.table.length * this.table.page - this.table.length + 1;

            if (valStart > this.table.total) {
                valStart = 1;
            }
            if (this.table.total == 0) {
                valStart = 0;
            }
            let valEnd = this.table.length * this.table.page;

            if (valEnd > this.table.total) {
                valEnd = this.table.total;
            }

            if (
                this.table.totalSearch < this.table.total &&
                this.table.search != ""
            ) {
                valEnd = this.table.totalSearch;
            }

            this.table.start = valStart;
            this.table.end = valEnd;
        },
        handleApprove(id, po) {
            this.deleteId = id;
            this.$vs.dialog({
                type: "confirm",
                title: `Confirm`,
                text: "Are you sure to approve this data?",
                accept: () => {
                    const basePath = po > 0 ? this.$store.state.purchase.poReturn.baseUrlPath : this.$store.state.purchase.supplierReturn.baseUrlPath
                    this.$vs.loading();
                    this.$http.post(`${basePath}/${id}/status/released`)
                    .then((resp) => {
                        this.$vs.loading.close();
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: "The data was successfully approved.",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                            this.getData();
                        } else {
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            });
                        }
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        console.log(error)
                        this.$vs.dialog({
                            color: "danger",
                            title: "Error",
                            text: error,
                        });
                    });
                },
            });
        },
        handleDetail(id, po, pro) {
            this.$router.push({
                name: this.$store.state.purchase.poReturn.baseRouterName + ".approval.detail",
                params: { id: id, po: po, pro: pro },
            });
        },
        handleReject(id, po) {
            // this.deleteId = id;
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to rejecting this data?",
                accept: () => {
                    this.$vs.loading();
                    const baseUrl = po > 0 ? this.$store.state.purchase.poReturn.baseUrlPath : this.$store.state.purchase.supplierReturn.baseUrlPath
                    this.$http.post(`${baseUrl}/${id}/status/rejected`)
                    .then((resp) => {
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: "The data was successfully rejected",
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        } else {
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            });
                        }

                        this.$vs.loading.close();
                        this.getData();
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        console.log(error)
                        this.$vs.dialog({
                            color: "danger",
                            title: "Error",
                            text: error,
                        });
                    });
                },
            });
        },
        handleApproveAll() {
            var sr = [];
            var pr = [];
            this.selected.forEach((v) => {
                v.purchase_order_id > 0 ? pr.push(v.id) : sr.push(v.id);
            });
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to approve all selected purchase return?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post(`${this.$store.state.purchase.poReturn.baseUrlPath}/approve-all`, {
                            "pr": pr,
                            "sr": sr,
                    })
                    .then((resp) => {
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: resp.message,
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        } else {
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            });
                        }
                        this.$vs.loading.close();
                        this.getData();
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        console.log(error)
                        this.$vs.dialog({
                            color: "danger",
                            title: "Error",
                            text: error,
                        });
                    });
                },
            });
        },
        handleRejectAll() {
            var sr = [];
            var pr = [];
            this.selected.forEach((v) => {
                v.purchase_order_id > 0 ? pr.push(v.id) : sr.push(v.id);
            });
            this.$vs.dialog({
                type: "confirm",
                color: "danger",
                title: `Confirm`,
                text: "Are you sure to reject all selected purchase return?",
                accept: () => {
                    this.$vs.loading();
                    this.$http.post(`${this.$store.state.purchase.poReturn.baseUrlPath}/reject-all`, {
                            "pr": pr,
                            "sr": sr,
                    })
                    .then((resp) => {
                        if (resp.code == 200) {
                            this.$vs.notify({
                                color: "success",
                                title: "Success",
                                text: resp.message,
                                position: "top-right",
                                iconPack: "feather",
                                icon: "icon-x-circle",
                            });
                        } else {
                            this.$vs.dialog({
                                color: "danger",
                                title: "Something went wrong",
                                text: resp.message,
                            });
                        }
                        this.$vs.loading.close();
                        this.getData();
                    })
                    .catch(error => {
                        this.$vs.loading.close();
                        console.log(error)
                        this.$vs.dialog({
                            color: "danger",
                            title: "Error",
                            text: error,
                        });
                    });
                },
            });
        },
        utcToLocal(val) {
            if (val) {
                return moment(val)
                    .add(-7, "h")
                    .utc()
                    .local()
                    .format("DD MMM YYYY HH:mm:ss");
            }
        },
    },
    mounted() {
        // ...
    },
    watch: {
        draw() {
            this.getData();
        },
        localDraw() {
            this.getData();
        },
    },
    computed: {
        setPage: {
            get() {
                return 1;
            },
            set(val) {
                this.handleChangePage(val);
            },
        },
        formatDate: () => {
            return (val) => moment.utc(val).format("YYYY-MM-DD")
        },
        formatLocalNumber: () => {
            return (val) => {
                return Number(val).toLocaleString("id-ID");
            };
        },
    },
};
</script>
  